// src/lib/controle-agent-api.js — REPRISES DE L'AGENT CONTRÔLÉ (client)
//
// Client des 2 actions serveur côté agent (lib/controles-handlers.js, routées
// par /api/beds24-mapping en POST { action, ... }) :
//   · controle_agent_reprises   → { reprises: [...] } — les contrôles portant
//     sur SES ménages (≤ 7 j), points + photos signées + échéance théorique ;
//   · controle_agent_point_fait → coche UN point repris ({ controle_id, index }).
//
// 🔴 ANONYMAT DU CONTRÔLEUR : la réponse serveur ne porte JAMAIS l'identité du
// contrôleur (ni email, ni prénom) — c'est structurel côté serveur (la colonne
// n'est pas sélectionnée), ce client n'a donc rien à filtrer et ne doit JAMAIS
// se mettre à demander « qui ». Le cloisonnement (assigned = email JWT) est
// résolu CÔTÉ SERVEUR — ce client n'envoie aucun scope.
//
// Les erreurs HTTP portent leur statut sur `err.status` (404 reprise inconnue /
// hors périmètre, 403 reprise sur place, 409 close ou modifiée entre-temps,
// 400 index invalide). Une erreur réseau porte `err.reseau = true`.

import { supabase } from '../supabase'

const ENDPOINT = '/api/beds24-mapping'

async function postAction(body) {
  let res
  try {
    const { data: { session } } = await supabase.auth.getSession()
    const token = session?.access_token
    res = await fetch(ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify(body),
    })
  } catch (e) {
    // Erreur réseau — message générique, jamais de PII.
    const err = new Error('Connexion impossible. Réessayez.')
    err.reseau = true
    throw err
  }
  const json = await res.json().catch(() => ({}))
  if (!res.ok) {
    const err = new Error(json.error || `Erreur ${res.status}`)
    err.status = res.status
    throw err
  }
  return json
}

// Les reprises de l'agent : { reprises: [{ id, run_id, logement_id,
// scheduled_date, statut, reprise_par, points: [{ categorie, texte,
// photos: [url…] }], reprise: [{ index, fait }],
// echeance: null | { prenom, date, heure } }] }.
export async function fetchReprisesAgent() {
  return postAction({ action: 'controle_agent_reprises' })
}

// Coche le point `index` du contrôle `controleId`. Rend { ok, statut,
// reprise } — statut passe à 'regle' quand TOUS les points sont faits.
// L'HISTORIQUE de ses contrôles reçus (Mon travail, 2026-08-22) — 90 jours,
// points sans photos, JAMAIS l'identité du contrôleur.
export async function fetchHistoriqueControles() {
  return postAction({ action: 'controle_agent_historique' })
}

// Les contrôles du MOIS qui lui reviennent (Le mois agent, 2026-08-22).
export async function fetchControlesMois(month) {
  return postAction({ action: 'controle_agent_mois', month })
}

export async function pointFait({ controleId, index }) {
  return postAction({ action: 'controle_agent_point_fait', controle_id: controleId, index })
}

// La PHOTO de sa reprise (2026-08-19) — facultative, UNE par point. La photo
// transite par le serveur (base64) ; la réponse porte photo_url SIGNÉE pour
// la vignette immédiate. Indépendante de la coche.
export async function photoReprise({ controleId, index, mime, dataBase64 }) {
  return postAction({
    action: 'controle_agent_photo_reprise',
    controle_id: controleId, index, mime, data_base64: dataBase64,
  })
}
